import { defineStore } from 'pinia'
import { api, removePhoneNumberCountryPrefix } from '@dpgradio/creative'

export const useUserStore = defineStore('user', {
  state: () => ({
    shouldConfirmMobile: false,
    profile: null,
  }),
  actions: {
    async fetchProfile() {
      if (!this.profile) {
        this.profile = await api.members.me()
      }
      return this.profile
    },
    async initConfirmationRequirement() {
      const confirmedMobile = localStorage.getItem('confirmedMobile')

      if (!confirmedMobile) {
        await this.fetchProfile()
      }

      this.shouldConfirmMobile = !confirmedMobile
    },
    async confirmMobile(mobile) {
      if (
        !this.profile.mobile ||
        removePhoneNumberCountryPrefix(this.profile.mobile) !== removePhoneNumberCountryPrefix(mobile)
      ) {
        await api.members.updateProfile({ mobile })
      }

      localStorage.setItem('confirmedMobile', true)
      this.shouldConfirmMobile = false
    },
  },
})
